/**
 * @author        calvin@zumper.com (Calvin Yau)
 * @copyright     Copyright (c) 2023, Zumper
 * @description   CityGuideNeighborhood Bizo
 */

import type { CityGuideNeighborhood, RawCityGuideNeighborhood } from '@zcode/state-type'
import { Bizo, autoclass } from '../../shared/bizos/base'

const DEFINITION = {
  articles: 'articles',
  content: 'content',
  costOfLiving: 'cost_of_living',
  demographics: 'demographics',
  industries: 'industries',
  pois: 'pois',
  survey: 'survey',
  topEmployers: 'top_employers',
  transportation: 'transportation',
  transportationSupplemental: 'transportation_supplemental',
} as const

export const CityGuideNeighborhoodData = autoclass<CityGuideNeighborhood, RawCityGuideNeighborhood>(
  'CityGuideNeighborhoodData',
  class CityGuideNeighborhoodData extends Bizo<CityGuideNeighborhood, RawCityGuideNeighborhood> {},
  DEFINITION,
  null
)
